// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"055bb659","178":"d6b94b02","402":"05ae4b72","516":"52b2f183","766":"fd69244a","787":"2f7bf333"}[chunkId] + ".chunk.js";
};